import type { LegalSection } from './LegalPage';

/**
 * Terms & Conditions body, shared by the standalone /terms page and the dialog
 * the onboarding Sign step opens. Review with counsel before relying on it.
 */
export const TERMS_META = {
  title: 'Terms & Conditions',
  updated: 'June 11, 2026',
  intro:
    'These Terms & Conditions govern your use of the Vib3 express business audit service. By accessing or using the service, you agree to be bound by these terms.',
};

export const TERMS_SECTIONS: LegalSection[] = [
  {
    heading: 'Acceptance of terms',
    paragraphs: [
      'By creating an account or using the service, you confirm that you have read, understood, and agree to these terms. If you do not agree, do not use the service.',
    ],
  },
  {
    heading: 'Description of the service',
    paragraphs: [
      'Vib3 provides an express audit of online businesses based on the data you connect and the information you provide. The output is a report and an analyst call with findings and recommendations.',
    ],
  },
  {
    heading: 'Accounts and eligibility',
    paragraphs: [
      'You must provide accurate information and are responsible for activity under your account. You must have authority to connect any data sources you link to the service.',
    ],
  },
  {
    heading: 'Connected data and authorizations',
    paragraphs: [
      'You grant us permission to access connected platform data with read-only scope solely to produce your audit. You may revoke access at any time through the connected platform or by contacting us.',
    ],
  },
  {
    heading: 'Acceptable use',
    paragraphs: [
      'You agree not to misuse the service, attempt to access it in unauthorized ways, or use it to violate any law or the rights of others.',
    ],
  },
  {
    heading: 'Intellectual property',
    paragraphs: [
      'The service, including its software and design, is owned by Vib3. The report we deliver is provided for your internal business use. Your underlying business data remains yours.',
    ],
  },
  {
    heading: 'Disclaimers',
    paragraphs: [
      'The service is provided “as is”. Our analysis and recommendations are informational and do not constitute legal, financial, or investment advice. We do not guarantee specific business outcomes.',
    ],
  },
  {
    heading: 'Limitation of liability',
    paragraphs: [
      'To the maximum extent permitted by law, Vib3 is not liable for indirect, incidental, or consequential damages arising from your use of the service.',
    ],
  },
  {
    heading: 'Termination',
    paragraphs: [
      'You may stop using the service at any time. We may suspend or terminate access if these terms are violated or as required to protect the service.',
    ],
  },
  {
    heading: 'Changes to these terms',
    paragraphs: [
      'We may update these terms from time to time. Continued use after changes take effect constitutes acceptance of the updated terms.',
    ],
  },
  {
    heading: 'Governing law',
    paragraphs: [
      'These terms are governed by the laws of the jurisdiction in which Vib3 operates, without regard to conflict-of-law principles.',
    ],
  },
];
